// Date utility functions for trips

import { TripDates } from '../api/tripsApi';

export const formatTripDates = (dates: TripDates | undefined): string => {
  if (!dates) return 'No dates set';
  
  const { startDate, endDate, startOffsetDaysPositive, startOffsetDaysNegative, endOffsetDaysPositive, endOffsetDaysNegative } = dates;
  
  if (!startDate || !endDate) return 'No dates set';
  
  // Calculate actual dates with offsets
  const start = new Date(startDate);
  if (startOffsetDaysPositive) {
    start.setDate(start.getDate() + startOffsetDaysPositive);
  } else if (startOffsetDaysNegative) {
    start.setDate(start.getDate() - startOffsetDaysNegative);
  }
  
  const end = new Date(endDate);
  if (endOffsetDaysPositive) {
    end.setDate(end.getDate() + endOffsetDaysPositive);
  } else if (endOffsetDaysNegative) {
    end.setDate(end.getDate() - endOffsetDaysNegative);
  }
  
  const startFormatted = formatDate(startDate);
  const endFormatted = formatDate(endDate);
  
  if (startFormatted === endFormatted) {
    return startFormatted;
  }
  
  return `${startFormatted} - ${endFormatted}`;
};

export const formatDateDisplay = (dateStr: string): string => {
  return formatDate(dateStr);
};

const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
};

export const calculateDaysRemaining = (dates: TripDates | undefined): number | null => {
  if (!dates || !dates.startDate) return null;
  
  const start = new Date(dates.startDate);
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  
  const diffTime = start.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays > 0 ? diffDays : null;
};

